import client from "clients/configs";
import { Keys } from "../_keys";

export const onResponseCreateCorp = (
  data: any,
  error: any,
  variables: any
) => {};
